import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const signupApis = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        userSignup: builder.mutation({
            query: (payload) => ({
                url: '/v0/user/signup',
                method: RequestTypes.POST,
                body: payload
            })
        }),
        verifyOtp: builder.mutation({
            query: (payload) => ({
                url: '/v0/user/verify/otp',
                method: RequestTypes.POST,
                body: payload
            })
        }),
        resendOtp: builder.mutation({
            query: (payload) => ({
                url: '/v0/user/verify/otp/resend',
                method: RequestTypes.POST,
                body: payload
            })
        })
    })
});

export const { useUserSignupMutation, useVerifyOtpMutation, useResendOtpMutation } = signupApis;
